import { h1 } from "@/styles/typography";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const ItemImage = styled(GatsbyImage)`
`;

const S = {
  ItemImage
};

export default S;
